module.exports = __webpack_public_path__ + "img/shadow-bg.ea1571a9.png";